module.exports = __webpack_public_path__ + "img/marketing.6c23df76.png";